import Sliders from './Sliders.mjs';

export default class Footer {
  constructor() {
    Sliders.initFooterAdvantagesCarousel();
    Sliders.initFooterCarousel();
  }
}
